import { Theme } from '@material-ui/core/styles'
import { CompanyStatus } from '../../../../models'
import { CompanyWithInvoiceCode } from '../types'

export const EDITABLE_STATUS_OPTIONS = Object.values(CompanyStatus).filter(
    (s) =>
        s !== CompanyStatus.MANUAL_REMOVE_FROM_NVL &&
        s !== CompanyStatus.IN_HOUSE,
)

export const formatStatusLabel = (status: string) =>
    status
        .split('_')
        .map(
            (word) =>
                word.charAt(0).toUpperCase() + word.slice(1).toLowerCase(),
        )
        .join(' ')

export const getStatusDotColor = (status: CompanyStatus, theme: Theme) => {
    switch (status) {
        case CompanyStatus.ACTIVE:
            return theme.palette.success.main
        case CompanyStatus.IN_ACTIVE:
            return theme.palette.error.main
        case CompanyStatus.TEST:
            return theme.palette.info.main
        default:
            return theme.palette.grey[500]
    }
}

const STATUS_DISPLAY_ORDER: CompanyStatus[] = [
    CompanyStatus.ACTIVE,
    CompanyStatus.IN_ACTIVE,
    CompanyStatus.SUSPENDED,
    CompanyStatus.TEST,
    CompanyStatus.IN_HOUSE,
    CompanyStatus.MANUAL_REMOVE_FROM_NVL,
]

export type StatusBreakdownEntry = {
    status: CompanyStatus
    count: number
}

export const getStatusBreakdown = (
    properties: CompanyWithInvoiceCode[],
): StatusBreakdownEntry[] => {
    const counts = new Map<CompanyStatus, number>()
    properties.forEach((property) => {
        counts.set(property.status, (counts.get(property.status) ?? 0) + 1)
    })

    return STATUS_DISPLAY_ORDER.filter((status) => counts.has(status)).map(
        (status) => ({
            status,
            count: counts.get(status)!,
        }),
    )
}
